// modules/TableField.jsx
import React from "react";
import {
  Box,
  Typography,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  IconButton,
  Button,
  Card,
  CardContent,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";

const TableField = ({
  module,
  value,
  isEditable,
  fieldKey,
  onCellChange,
  onAddRow,
  onRemoveRow,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const tableRows = value || [];

  return (
    <Box marginY={2}>
      <Typography variant="h6">{module.label}</Typography>

      {isMobile ? (
        // Stacked card layout for small screens
        <Box>
          {tableRows.map((row, rowIndex) => (
            <Card key={rowIndex} variant="outlined" sx={{ mb: 1 }}>
              <CardContent sx={{ pb: "12px !important" }}>
                {module.columns.map((col, colIndex) => (
                  <Box key={colIndex} sx={{ mb: 1.5 }}>
                    <Typography variant="caption" color="text.secondary">
                      {col}
                    </Typography>
                    <TextField
                      value={row[col]}
                      onChange={(e) =>
                        onCellChange(fieldKey, rowIndex, col, e.target.value)
                      }
                      fullWidth
                      size="small"
                      InputProps={{ readOnly: !isEditable }}
                      disabled={!isEditable}
                    />
                  </Box>
                ))}
                {isEditable && (
                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <IconButton
                      onClick={() => onRemoveRow(fieldKey, rowIndex)}
                      color="error"
                      size="small"
                    >
                      <RemoveCircleIcon />
                    </IconButton>
                  </Box>
                )}
              </CardContent>
            </Card>
          ))}
        </Box>
      ) : (
        // Standard table layout for larger screens
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                {module.columns.map((col, colIndex) => (
                  <TableCell key={colIndex}>{col}</TableCell>
                ))}
                {isEditable && <TableCell align="right">Actions</TableCell>}
              </TableRow>
            </TableHead>
            <TableBody>
              {tableRows.map((row, rowIndex) => (
                <TableRow key={rowIndex}>
                  {module.columns.map((col, colIndex) => (
                    <TableCell key={colIndex}>
                      <TextField
                        value={row[col]}
                        onChange={(e) =>
                          onCellChange(fieldKey, rowIndex, col, e.target.value)
                        }
                        fullWidth
                        InputProps={{ readOnly: !isEditable }}
                        disabled={!isEditable}
                      />
                    </TableCell>
                  ))}
                  {isEditable && (
                    <TableCell align="right">
                      <IconButton
                        onClick={() => onRemoveRow(fieldKey, rowIndex)}
                        color="error"
                      >
                        <RemoveCircleIcon />
                      </IconButton>
                    </TableCell>
                  )}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {isEditable && (
        <Button
          variant="outlined"
          startIcon={<AddCircleIcon />}
          onClick={() => onAddRow(fieldKey, module.columns)}
          sx={{ marginTop: 1 }}
        >
          Add Row
        </Button>
      )}
    </Box>
  );
};

export default TableField;
